// this file is automatically generated by sourcemaps.js script
export const versions = {commitHash: '0ce54935', branch: 'HEAD'};